// extracted by mini-css-extract-plugin
module.exports = {"input":"autocomplete-input__26d1j","suggestions":"autocomplete-suggestions__dczDU","suggestion_active":"autocomplete-suggestion_active__3ETbz"};